import { defineMessages } from "react-intl";

const baseId = "t.pages.UserEntitlements.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "USER ENTITLEMENT",
  },
  goBack: {
    id: baseId + "goBack",
    defaultMessage: "Back to the Homepage",
  },
  entitlements: {
    id: baseId + "entitlements",
    defaultMessage: "Entitlements",
  },
  businessRoleEntitlements: {
    id: baseId + "businessRoleEntitlements",
    defaultMessage: "Business role entitlements",
  },
  emptyTable: {
    id: baseId + "emptyTable",
    defaultMessage: "No result found",
  },
  // Filter
  allFilterLabelForm: {
    id: baseId + "allFilterLabelForm",
    defaultMessage: "Application, Entitlement",
  },
});
